import axiosInstance from "./AxiosConfig";

class PriceModifierApi {

  // ---------------- CREATE ----------------
  async CreatePriceModifier(data) {
    try {
      const response = await axiosInstance.post(
        "/priceModifier/create",
        data
      );
      return response.data;
    } catch (error) {
      console.error("CreatePriceModifier Error:", error);
      return null;
    }
  }

  // ---------------- GET ALL ----------------
  async GetAllPriceModifiers() {
    try {
      const response = await axiosInstance.get(
        `/priceModifier/get`
      );
      return response.data;
    } catch (error) {
      console.error("GetAllPriceModifiers Error:", error);
      return null;
    }
  }

  // ---------------- GET BY ID ----------------
  async GetPriceModifierById(id) {
    try {
      const response = await axiosInstance.get(
        `/priceModifier/get/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("GetPriceModifierById Error:", error);
      return null;
    }
  }

  // ---------------- UPDATE ----------------
  async UpdatePriceModifier(id, data) {
    try {
      const response = await axiosInstance.put(
        `/priceModifier/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("UpdatePriceModifier Error:", error);
      return null;
    }
  }

  // ---------------- DELETE ----------------
  async DeletePriceModifier(id) {
    try {
      const response = await axiosInstance.delete(
        `/priceModifier/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("DeletePriceModifier Error:", error);
      return null;
    }
  }

  // ---------------- GET BY BRANCH ID ----------------
  async GetByBranchId(id) {
    try {
      const response = await axiosInstance.get(
        `/priceModifier/getByBranchId/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("GetPriceModifierById Error:", error);
      return null;
    }
  }
}

export default new PriceModifierApi();